import { isURL } from '@/utils/validate'
import { BlankLayout } from '@/components/layouts'

export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : (hour <= 11 ? '上午好' : (hour <= 13 ? '中午好' : (hour < 20 ? '下午好' : '晚上好')))
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  let index = Math.floor((Math.random() * arr.length))
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  let event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

/**
 * 过滤对象中为空的属性
 * @param obj
 * @returns {*}
 */
export function filterObj(obj) {
  if (!(typeof obj == 'object')) {
    return;
  }

  for (var key in obj) {
    if (obj.hasOwnProperty(key)
      && (obj[key] == null || obj[key] == undefined || obj[key] === '')) {
      delete obj[key];
    }
  }
  return obj;
}

/**
 * 时间格式化
 * @param value
 * @param fmt
 * @returns {*}
 */
export function formatDate(value, fmt) {
  var regPos = /^\d+(\.\d+)?$/;
  if (regPos.test(value)) {
    //如果是数字
    let getDate = new Date(value);
    let o = {
      'M+': getDate.getMonth() + 1,
      'd+': getDate.getDate(),
      'h+': getDate.getHours(),
      'm+': getDate.getMinutes(),
      's+': getDate.getSeconds(),
      'q+': Math.floor((getDate.getMonth() + 3) / 3),
      'S': getDate.getMilliseconds()
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt;
  } else {
    //TODO
    value = value.trim();
    return value.substr(0, fmt.length);
  }
}

export function setMapTile(map) {
  // 添加叠加图层
  var nameFormat = "{x}_{y}";
  var tilerLayer = new AMap.TileLayer({
    zIndex: 10000,
    getTileUrl: function (x, y, z) {
      var name = nameFormat
        .replace("{x}", x)
        .replace("{y}", y)
        .replace("{z}", z)
        ;
      return `/img/map/${window.localStorage.getItem('projectCode')}/tiles/${z}/${name}.png`;
    }
  });
  tilerLayer.setMap(map)
}

// 生成首页路由
export function generateIndexRouter(data) {
  let homeUrl = (window.localStorage.getItem('homeUrl') && window.localStorage.getItem('homeUrl') != 'null' && window.localStorage.getItem('homeUrl') != 'undefined') ? window.localStorage.getItem('homeUrl') : '/monitor/map'

  let indexRouter = [{
    path: '/',
    name: 'dashboard',
    //component: () => import('@/components/layouts/BasicLayout'),
    component: resolve => require(['@/components/layouts/TabLayout'], resolve),
    meta: { title: '首页' },
    redirect: homeUrl,
    children: [
      ...generateChildRouters(data)
    ]
  }, {
    "path": "*", "redirect": "/404", "hidden": true
  }]
  return indexRouter;
}

// 生成嵌套路由（子路由）

function generateChildRouters(data) {
  const routers = [];
  for (var item of data) {
    let component = "";
    let tenantcomponent = "";
    let tenantCode = window.localStorage.getItem('projectCode');
    if (item.component.indexOf("layouts") >= 0) {
      component = "components/" + item.component;
      tenantcomponent = "components/" + item.component;
    } else {
      component = "views/" + item.component;
      tenantcomponent = "views/tenant/" + tenantCode + "/" + item.component;
    }

    // eslint-disable-next-line
    let URL = (item.meta.url || '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
    if (isURL(URL)) {
      item.meta.url = URL;
    }

    let menu = {
      path: item.path,
      name: item.name,
      redirect: item.redirect,
      component: () => {
        try {
          //如果存在租户定制化页面则进入租户定制化页面
          return Promise.resolve(require('@/' + tenantcomponent + '.vue').default)
        }
        catch (e) {
          //报错说明租户定制化页面不存在，进入菜单配置界面
          return Promise.resolve(require('@/' + component + '.vue').default);
        }
      },
      // component: resolve => require(['@/' + component + '.vue'], resolve),
      hidden: item.hidden,
      //component:()=> import(`@/views/${item.component}.vue`),
      meta: {
        title: item.meta.title,
        icon: item.meta.icon,
        url: item.meta.url,
        permissionList: item.meta.permissionList,
        keepAlive: item.meta.keepAlive
      }
    }
    /*let tenantmenu = {
      path: item.path.indexOf("layouts")>=0?item.path:"/tenant/"+tenantCode +item.path,
      name: item.name,
      redirect: item.redirect,
      component: () => {
        try {
          return Promise.resolve(require('@/' + tenantcomponent + '.vue').default)
        }
        catch (e) {
          return Promise.resolve(require('@/' + component + '.vue').default);
        }
      },
      hidden: item.hidden,
      //component:()=> import(`@/views/${item.component}.vue`),
      meta: {
        title: item.meta.title,
        icon: item.meta.icon,
        url: item.meta.url,
        permissionList: item.meta.permissionList,
        keepAlive: item.meta.keepAlive
      }
    }*/
    if (item.alwaysShow) {
      menu.alwaysShow = true;
      menu.redirect = menu.path;
      // tenantmenu.alwaysShow = true;
      // tenantmenu.redirect = tenantmenu.path;
    }
    if (item.children && item.children.length > 0) {
      menu.children = [...generateChildRouters(item.children)];
      // tenantmenu.children = menu.children;
    }
    //--update-begin----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
    //判断是否生成路由
    if (item.route && item.route === '0') {
      //console.log(' 不生成路由 item.route：  '+item.route);
      //console.log(' 不生成路由 item.path：  '+item.path);
    } else {
      routers.push(menu);
      // routers.push(tenantmenu);
    }
    //--update-end----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
  }
  return routers
}

/**
 * 深度克隆对象、数组
 * @param obj 被克隆的对象
 * @return 克隆后的对象
 */
export function cloneObject(obj) {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * 随机生成数字
 *
 * 示例：生成长度为 12 的随机数：randomNumber(12)
 * 示例：生成 3~23 之间的随机数：randomNumber(3, 23)
 *
 * @param1 最小值 | 长度
 * @param2 最大值
 * @return int 生成后的数字
 */
export function randomNumber() {
  // 生成 最小值 到 最大值 区间的随机数
  const random = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }
  if (arguments.length === 1) {
    let [length] = arguments
    // 生成指定长度的随机数字，首位一定不是 0
    let nums = [...Array(length).keys()].map((i) => (i > 0 ? random(0, 9) : random(1, 9)))
    return parseInt(nums.join(''))
  } else if (arguments.length >= 2) {
    let [min, max] = arguments
    return random(min, max)
  } else {
    return Number.NaN
  }
}

/**
 * 随机生成字符串
 * @param length 字符串的长度
 * @param chats 可选字符串区间（只会生成传入的字符串中的字符）
 * @return string 生成的字符串
 */
export function randomString(length, chats) {
  if (!length) length = 1
  if (!chats) chats = '0123456789qwertyuioplkjhgfdsazxcvbnm'
  let str = ''
  for (let i = 0; i < length; i++) {
    let num = randomNumber(0, chats.length - 1)
    str += chats[num]
  }
  return str
}

/**
 * 随机生成uuid
 * @return string 生成的uuid
 */
export function randomUUID() {
  let chats = '0123456789abcdef'
  return randomString(32, chats)
}

/**
 * 下划线转驼峰
 * @param string
 * @returns {*}
 */
export function underLine2CamelCase(string) {
  return string.replace(/_([a-z])/g, function (all, letter) {
    return letter.toUpperCase();
  });
}

/**
 * 判断是否显示办理按钮
 * @param bpmStatus
 * @returns {*}
 */
export function showDealBtn(bpmStatus) {
  if (bpmStatus != "1" && bpmStatus != "3" && bpmStatus != "4") {
    return true;
  }
  return false;
}


/**
 * 精确除法
 *
 */
export function accDiv(arg1, arg2) {
  var t1 = 0,
    t2 = 0,
    r1,
    r2
  try {
    t1 = arg1.toString().split('.')[1].length
  } catch (e) { }
  try {
    t2 = arg2.toString().split('.')[1].length
  } catch (e) { }
  Math.r1 = Number(arg1.toString().replace('.', ''))
  Math.r2 = Number(arg2.toString().replace('.', ''))
  return ((Math.r1 / Math.r2) * Math.pow(10, t2 - t1)).toFixed(2)
}
/**
 * 精确乘法
 *
 */
export function accMul(arg1, arg2) {
  var max = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString()
  try {
    max += s1.split('.')[1].length
  } catch (e) { }
  try {
    max += s2.split('.')[1].length
  } catch (e) { }
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, max)
}

export function accSum(arg1, arg2) {
  var r1, r2, m
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

/**
 * 减法
 * @param arg1
 * @param arg2
 * @returns
 */
export function accSubtr(arg1, arg2) {
  var r1, r2, m, n;
  try { r1 = arg1.toString().split(".")[1].length; } catch (e) { r1 = 0; }
  try { r2 = arg2.toString().split(".")[1].length; } catch (e) { r2 = 0; }
  m = Math.pow(10, Math.max(r1, r2));
  //动态控制精度长度
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

// 判断是不是永春项目
export function isYongChun() {
  if (window.localStorage.getItem('areaNameList')) {
    return window.localStorage.getItem('areaNameList').indexOf('永春') != -1
  } else {
    return false
  }
}

export function isNullOrEmpty(value) {
  //是否为空
  return (value === null || value === '' || value === 'null' || value === undefined) ? true : false;
}

// ==================== 坐标系转换工具 ====================
// WGS84 (GPS/卫星地图) <-> GCJ02 (高德/腾讯地图)

const PI = Math.PI
const SEMI_MAJOR_AXIS = 6378245.0 // 克拉索夫斯基椭球体长半轴
const ECCENTRICITY_SQUARED = 0.00669342162296594323 // 椭球体第一偏心率平方

/**
 * 判断坐标是否在中国境外（境外不需要偏移）
 * @param {number} lng 经度
 * @param {number} lat 纬度
 * @returns {boolean}
 */
function isOutOfChina(lng, lat) {
  return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55)
}

/**
 * 纬度偏移量计算
 */
function transformLat(lng, lat) {
  let ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng))
  ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0
  ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0
  ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0
  return ret
}

/**
 * 经度偏移量计算
 */
function transformLng(lng, lat) {
  let ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng))
  ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0
  ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0
  ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0
  return ret
}

/**
 * WGS84 转 GCJ02（GPS坐标 转 高德坐标）
 * @param {number} lng WGS84 经度
 * @param {number} lat WGS84 纬度
 * @returns {number[]} [GCJ02经度, GCJ02纬度]
 */
export function wgs84ToGcj02(lng, lat) {
  lng = parseFloat(lng)
  lat = parseFloat(lat)
  if (isOutOfChina(lng, lat)) {
    return [lng, lat]
  }
  let dLat = transformLat(lng - 105.0, lat - 35.0)
  let dLng = transformLng(lng - 105.0, lat - 35.0)
  const radLat = lat / 180.0 * PI
  let magic = Math.sin(radLat)
  magic = 1 - ECCENTRICITY_SQUARED * magic * magic
  const sqrtMagic = Math.sqrt(magic)
  dLat = (dLat * 180.0) / ((SEMI_MAJOR_AXIS * (1 - ECCENTRICITY_SQUARED)) / (magic * sqrtMagic) * PI)
  dLng = (dLng * 180.0) / (SEMI_MAJOR_AXIS / sqrtMagic * Math.cos(radLat) * PI)
  const mgLat = lat + dLat
  const mgLng = lng + dLng
  return [mgLng, mgLat]
}

/**
 * GCJ02 转 WGS84（高德坐标 转 GPS坐标）
 * @param {number} lng GCJ02 经度
 * @param {number} lat GCJ02 纬度
 * @returns {number[]} [WGS84经度, WGS84纬度]
 */
export function gcj02ToWgs84(lng, lat) {
  lng = parseFloat(lng)
  lat = parseFloat(lat)
  if (isOutOfChina(lng, lat)) {
    return [lng, lat]
  }
  let dLat = transformLat(lng - 105.0, lat - 35.0)
  let dLng = transformLng(lng - 105.0, lat - 35.0)
  const radLat = lat / 180.0 * PI
  let magic = Math.sin(radLat)
  magic = 1 - ECCENTRICITY_SQUARED * magic * magic
  const sqrtMagic = Math.sqrt(magic)
  dLat = (dLat * 180.0) / ((SEMI_MAJOR_AXIS * (1 - ECCENTRICITY_SQUARED)) / (magic * sqrtMagic) * PI)
  dLng = (dLng * 180.0) / (SEMI_MAJOR_AXIS / sqrtMagic * Math.cos(radLat) * PI)
  const mgLat = lat + dLat
  const mgLng = lng + dLng
  return [lng * 2 - mgLng, lat * 2 - mgLat]
}

/**
 * 批量坐标转换 WGS84 -> GCJ02
 * @param {Array} coordArr 坐标数组，每个元素为 [lng, lat] 或 {lng, lat}
 * @returns {Array} 转换后的坐标数组
 */
export function batchWgs84ToGcj02(coordArr) {
  if (!coordArr || !coordArr.length) return []
  return coordArr.map(coord => {
    if (Array.isArray(coord)) {
      return wgs84ToGcj02(coord[0], coord[1])
    } else if (coord.lng !== undefined && coord.lat !== undefined) {
      const [lng, lat] = wgs84ToGcj02(coord.lng, coord.lat)
      return { lng, lat }
    }
    return coord
  })
}

/**
 * 批量坐标转换 GCJ02 -> WGS84
 * @param {Array} coordArr 坐标数组，每个元素为 [lng, lat] 或 {lng, lat}
 * @returns {Array} 转换后的坐标数组
 */
export function batchGcj02ToWgs84(coordArr) {
  if (!coordArr || !coordArr.length) return []
  return coordArr.map(coord => {
    if (Array.isArray(coord)) {
      return gcj02ToWgs84(coord[0], coord[1])
    } else if (coord.lng !== undefined && coord.lat !== undefined) {
      const [lng, lat] = gcj02ToWgs84(coord.lng, coord.lat)
      return { lng, lat }
    }
    return coord
  })
}